export function mapRoomLabel(value) {
  switch (value) {
    case "1":
      return "Stüdyo";
    case "2":
      return "1";
    case "3":
      return "1+1";
    case "5":
      return "2+1";
    case "6":
      return "2+2";
    case "7":
      return "3+1";
    case "8":
      return "3+2";
    case "9":
      return "4+1";
    case "10":
      return "4+2";
    case "11":
      return "5";
    case "12":
      return "5+1";
    case "13":
      return "5+2";
    case "14":
      return "5+3";
    case "15":
      return "5+4";
    case "16":
      return "6+1";
    case "17":
      return "6+2";
    case "18":
      return "7+1";
    case "19":
      return "8+";
    default:
      return "Bilinmeyen Değer";
  }
}
